import React from 'react';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import AjioWalletEventConstants from '../../../utils/AjioWalletEventConstants';
import { showModal, hideModal } from '../../../actions/modal';
import awConstants from '../../../utils/AjioWalletConstants';
import Modal from '../../../components/common/Modal';
import { getLuxeFlags } from '../../../Flags/selectors';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import { displayValueWithSymbol } from '../../../utils/price';
import { getVariant } from '../../../refresh/organism/ABFeature/Feature';
import { gtmEventPush, segmentEventPush } from '../../../modules/ga/GTMdatalayer';
import getShowCodConvenienceFlowFlag from '../../../refresh/utils/codConvenienceUtils';
import {
  getAjioMemberShipConfig,
  getBlockedForCancellationFlagMsite,
  getCodConvenienceData,
  getEnableAjioMemberShipProgram,
  getFreeShippingAmountLimit,
  getGiftWithProductConfig,
  getGiftWithProductEnable,
  getPaymentModesOnOrderPlacementFlag,
  getPriorityDeliveryPostOrderFlag,
  getRushDeliveryFlag,
  getReturnCodCommunication,
  getAjioSuperCashConfigForCart,
  getAjioSuperCashCurrencyConfig,
  getAjioWallet,
  getAjioSuperCashODPEnable,
  getStoreCredit,
  getEmiDiscountSPCConfig
} from '../../../refresh/selectors/featureFlagsSelector';
import Divider from '../../../refresh/atoms/Divider';
import OrderSummaryWithMOPs from './OrderSummaryWithMOPs';
import { SubscriptionStaticKeys } from '../../../constants/subscriptionStaticKey';
import RupeeSymbol from '../../../refresh/atoms/RupeeSymbol';
import { subscriptionTypes } from '../../../refresh/pages/SubscriptionLandingPage/constants';
import { getReturnWindowTextForGA } from '../../../utils/returnFormFlowOptimize';
import AjioSuperCash from '../desktop/AjioSuperCash/AjioSuperCash';

const handleKeyDown = e => {
  if (e.code === 'Enter' && e.target.tagName.toLowerCase() !== 'button') {
    document.activeElement.click();
  }
};

class OrderSummary extends React.Component {
  constructor(props) {
    super(props);
    (this.textContent = {
      orderSummary: 'Order Details',
      bagTotal: 'Bag total',
      bagDiscount: 'Bag discount',
      couponSaving: 'Coupon savings',
      delivery: 'Delivery',
      orderTotal: 'Total Amount',
      promoSaving: 'Promo savings',
      giftWrap: 'Gift wrap',
      storeCredit: 'AJIO Wallet',
      jioPrimePoint: 'Jio Prime Points redeemed',
      amountToBePaid: 'Balance Paid',
      estimatedGst: 'Applicable GST',
      bankDiscount: 'Bank Discount',
      loyaltyPoints: 'Loylty Rewardz Points',
      relianceOneAmount: 'RelianceOne Points',
      redeemedMahaCachBack: 'JioMart Maha Cashback',
      convenienceFee: 'Convenience Fee',
      whatsThis: "What's this?",
      orderDetails: 'Order Payment Details',
      orderAmount: 'Order Amount',
      orderSavings: 'Order Savings',
      paymentMode: 'Payment Mode',
      amountPayable: 'Amount Payable',
      orderTotal: 'Order Total',
      COD: 'Cash on Delivery',
      PrePaid: 'PrePaid',
      noCostEmiDiscount: this.props.noCostEmiDiscountTitle || 'No Cost EMI Discount'
    }),
      (this.state = {
        feeExplanation: false,
        orderStatus: ''
      });
  }

  componentDidMount() {
    const {
      source = '',
      storeName,
      convenienceFee = {},
      codConvenienceData = {},
      freeShippingAmountLimit = '1200',
      isConvenienceFeeEnabled,
      isThankYouPage,
      orderLevelDetail: { orderResponse = {} },
      isOrderBlockedForCancellationFlagMsite = false,
      enableGiftWithProduct,
      enableAjioMemberShipProgram,
      membershipBenefitResponse,
      isPaymentModesOnOrderPlacementFlag,
      returnCodCommunication = {},
      storeCreditValue,
      ajioSuperCashODPEnable
    } = this.props;
    const {
      code = '',
      entries,
      confirmedEntries = [],
      consignmentsData = [],
      cancelledEntries = [],
      membershipSavings = {},
      paymentSuccessful,
      isExchangeOrder
    } = orderResponse;
    const {
      convenienceFeeInfo = {},
      convenienceFeeNote = '',
      convenienceRefundPolicy: { readPolicyUrl = '' } = {}
    } = codConvenienceData;
    const { COD = {}, RVP = {}, delivery = {}, total = {} } = convenienceFee;

    consignmentsData.forEach(el => {
      const { entries: consignedEntries = [], returnRequests = [], shipmentStatus = '' } = el;

      consignedEntries.forEach(ce => {
        const { orderEntry: item = {} } = ce;

        let giftCount = 0;
        if (enableGiftWithProduct) {
          if (item?.isGiftProduct) return;
          giftCount = item?.giftProductsCount || 0;
        }

        const returnWindow = getReturnWindowTextForGA(returnCodCommunication, item);

        gtmEventPush({
          event: 'pageload',
          page_type: 'order management screen',
          rvp_fee: RVP?.netAmount,
          cod_fee_actual: COD?.netAmount,
          cod_fee_slashed: COD?.amount,
          delivery_fee_actual: delivery?.netAmount,
          delivery_fee_slashed: delivery?.amount,
          total_convenience_fee: total?.netAmount,
          product_id: item?.product?.code,
          product_name: item?.product?.name,
          order_id: code,
          order_status: String(shipmentStatus).toUpperCase(),
          reference_no: 'NA',
          refund_failure_count: 0,
          product_brand: item?.product?.brandName,
          product_brick: item?.product?.brickName,
          product_category: item?.product?.segmentName,
          iscancelorderblocked: 0,
          ...(giftCount > 0 && { offer_count: giftCount }),
          ...(enableAjioMemberShipProgram && {
            subscription_details: `${membershipBenefitResponse?.status || 'NA'} | ${membershipBenefitResponse?.detail?.productId || 'NA'} | ${membershipBenefitResponse?.detail?.identifier || 'NA'} | NA`, // TODO: please add the value of subscription_version and sub_no;
            subscription_delivery_fee_saving: membershipSavings?.deliveryFeeSavings,
            subscription_platform_fee_saving: membershipSavings?.platformFeeSavings,
            subscription_total_savings: membershipSavings?.totalMembershipSavings,
            subscription_membership_discount: membershipSavings?.membershipDiscount
          }),
          return_window: returnWindow,
          ...(ajioSuperCashODPEnable && { wallet_amount_used: storeCreditValue })
        });
      });

      returnRequests.forEach(rr => {
        const { returnEntries = [], impsFailed = false, returnStatus = '' } = rr;
        const [returnEntry = { entry: {} }] = returnEntries;
        const { entry: item = {} } = returnEntry;

        let giftCount = 0;
        if (enableGiftWithProduct) {
          if (item?.isGiftProduct) return;
          giftCount = item?.giftProductsCount || 0;
        }

        const returnWindow = getReturnWindowTextForGA(returnCodCommunication, item);

        gtmEventPush({
          event: 'pageload',
          page_type: 'order management screen',
          rvp_fee: RVP?.netAmount,
          cod_fee_actual: COD?.netAmount,
          cod_fee_slashed: COD?.amount,
          delivery_fee_actual: delivery?.netAmount,
          delivery_fee_slashed: delivery?.amount,
          total_convenience_fee: total?.netAmount,
          product_id: item?.product?.code,
          product_name: item?.product?.name,
          order_id: code,
          order_status: String(returnStatus).toUpperCase(),
          reference_no: 'NA',
          refund_failure_count: impsFailed ? 1 : 0,
          product_brand: item?.product?.brandName,
          product_brick: item?.product?.brickName,
          product_category: item?.product?.segmentName,
          iscancelorderblocked: 0,
          ...(giftCount > 0 && { offer_count: giftCount }),
          ...(enableAjioMemberShipProgram && {
            subscription_details: `${membershipBenefitResponse?.status || 'NA'} | ${membershipBenefitResponse?.detail?.productId || 'NA'} | ${membershipBenefitResponse?.detail?.identifier || 'NA'} | NA`, // TODO: please add the value of subscription_version and sub_no;
            subscription_delivery_fee_saving: membershipSavings?.deliveryFeeSavings,
            subscription_platform_fee_saving: membershipSavings?.platformFeeSavings,
            subscription_total_savings: membershipSavings?.totalMembershipSavings,
            subscription_membership_discount: membershipSavings?.membershipDiscount
          }),
          return_window: returnWindow,
          ...(ajioSuperCashODPEnable && { wallet_amount_used: storeCreditValue })
        });
      });
    });

    confirmedEntries.forEach(cfe => {
      const { entry: item = {} } = cfe;

      let orderStatus = 'Confirmed';
      if (paymentSuccessful === false) orderStatus = 'Payment Unsuccessful';
      if (isExchangeOrder === true) orderStatus = 'Exchange Confirmed';

      // FOR CHECKING "BLOCKED FOR CANCELLATION" STATUS OF ITEM
      const isOrderStatusAfterPacked =
        item.entryStatus == 'PACKED' ||
        item.entryStatus == 'SHIPPED' ||
        item.entryStatus == 'OUT FOR DELIVERY' ||
        item.entryStatus == 'DELIVERY DELAYED' ||
        item.entryStatus?.toLowerCase().includes('arriving');

      const isOrderBlockedForCancellationBeforePacked =
        isOrderBlockedForCancellationFlagMsite &&
        item.hasOwnProperty('isCancellable') &&
        !item.isCancellable &&
        !isOrderStatusAfterPacked;
      const isOrderBlockedForCancellationAfterPacked =
        isOrderBlockedForCancellationFlagMsite && isOrderStatusAfterPacked;

      let giftCount = 0;
      if (enableGiftWithProduct) {
        if (item?.isGiftProduct) return;
        giftCount = item?.giftProductsCount || 0;
      }

      const returnWindow = getReturnWindowTextForGA(returnCodCommunication, item);

      this.setState({
          orderStatus : orderStatus.toUpperCase()
      })

      gtmEventPush({
        event: 'pageload',
        page_type: 'order management screen',
        rvp_fee: RVP?.netAmount,
        cod_fee_actual: COD?.netAmount,
        cod_fee_slashed: COD?.amount,
        delivery_fee_actual: delivery?.netAmount,
        delivery_fee_slashed: delivery?.amount,
        total_convenience_fee: total?.netAmount,
        product_id: item?.product?.code,
        product_name: item?.product?.name,
        order_id: code,
        order_status: orderStatus.toUpperCase(),
        reference_no: 'NA',
        refund_failure_count: 0,
        product_brand: item?.product?.brandName,
        product_brick: item?.product?.brickName,
        product_category: item?.product?.segmentName,
        iscancelorderblocked:
          isOrderBlockedForCancellationBeforePacked || isOrderBlockedForCancellationAfterPacked
            ? 1
            : 0,
        ...(giftCount > 0 && { offer_count: giftCount }),
        ...(enableAjioMemberShipProgram && {
          subscription_details: `${membershipBenefitResponse?.status || 'NA'} | ${membershipBenefitResponse?.detail?.productId || 'NA'} | ${membershipBenefitResponse?.detail?.identifier || 'NA'} | NA`, // TODO: please add the value of subscription_version and sub_no;
          subscription_delivery_fee_saving: membershipSavings?.deliveryFeeSavings,
          subscription_platform_fee_saving: membershipSavings?.platformFeeSavings,
          subscription_total_savings: membershipSavings?.totalMembershipSavings,
          subscription_membership_discount: membershipSavings?.membershipDiscount
        }),
        return_window: returnWindow,
        ...(ajioSuperCashODPEnable && { wallet_amount_used: storeCreditValue })
      });
    });

    cancelledEntries.forEach(cce => {
      const { entry: item = {} } = cce;
      let giftCount = 0;
      if (enableGiftWithProduct) {
        if (item?.isGiftProduct) return;
        giftCount = item?.giftProductsCount || 0;
      }

      const returnWindow = getReturnWindowTextForGA(returnCodCommunication, item);

      gtmEventPush({
        event: 'pageload',
        page_type: 'order management screen',
        rvp_fee: RVP?.netAmount,
        cod_fee_actual: COD?.netAmount,
        cod_fee_slashed: COD?.amount,
        delivery_fee_actual: delivery?.netAmount,
        delivery_fee_slashed: delivery?.amount,
        total_convenience_fee: total?.netAmount,
        product_id: item?.product?.code,
        product_name: item?.product?.name,
        order_id: code,
        order_status: item?.newEntryStatus,
        reference_no: 'NA',
        refund_failure_count: 0,
        product_brand: item?.product?.brandName,
        product_brick: item?.product?.brickName,
        product_category: item?.product?.segmentName,
        iscancelorderblocked: 0,
        ...(giftCount > 0 && { offer_count: giftCount }),
        ...(enableAjioMemberShipProgram && {
          subscription_details: `${membershipBenefitResponse?.status || 'NA'} | ${membershipBenefitResponse?.detail?.productId || 'NA'} | ${membershipBenefitResponse?.detail?.identifier || 'NA'} | NA`, // TODO: please add the value of subscription_version and sub_no;
          subscription_delivery_fee_saving: membershipSavings?.deliveryFeeSavings,
          subscription_platform_fee_saving: membershipSavings?.platformFeeSavings,
          subscription_total_savings: membershipSavings?.totalMembershipSavings,
          subscription_membership_discount: membershipSavings?.membershipDiscount
        }),
        return_window: returnWindow,
        ...(ajioSuperCashODPEnable && { wallet_amount_used: storeCreditValue })
      });
    });

    document.addEventListener('keydown', handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', handleKeyDown);
  }

  gaEventsCodConvenience = () => {
    const {
      orderLevelDetail: { orderResponse = {} },
      convenienceFee = {}
    } = this.props;
    const { entries } = orderResponse;
    const { COD = {}, RVP = {}, delivery = {}, total = {} } = convenienceFee;
    gtmEventPush({
      event: 'pageload',
      page_name: 'Fee Explanation bottom screen',
      page_type: 'Fee Explanation bottom screen',
      rvp_fee: RVP?.netAmount,
      cod_fee_actual: COD?.netAmount,
      cod_fee_slashed: COD?.amount,
      delivery_fee_actual: delivery?.netAmount,
      delivery_fee_slashed: delivery?.amount,
      total_convenience_fee: total?.netAmount
    });
    entries?.map(item => {
      if (
        item.entryStatus == 'PARTIALLY_RETURNED' ||
        item.entryStatus == 'RETURN_INITIATED' ||
        item.entryStatus == 'PARTIALLY_DELIVERED' ||
        item.entryStatus == 'RECEIVED_AT_DC' ||
        item.entryStatus == 'CANCELLED'
      ) {
        gtmEventPush({
          event: 'whats_this_click',
          action: 'Whats this click',
          category: 'return order details interaction',
          rvp_fee: RVP?.netAmount,
          cod_fee_actual: COD?.netAmount,
          cod_fee_slashed: COD?.amount,
          delivery_fee_actual: delivery?.netAmount,
          delivery_fee_slashed: delivery?.amount,
          total_convenience_fee: total?.netAmount,
          page_type: 'order management screen'
        });
      } else {
        gtmEventPush({
          event: 'whats_this_click',
          action: 'Whats this click',
          category: 'order details interaction',
          rvp_fee: RVP?.netAmount,
          cod_fee_actual: COD?.netAmount,
          cod_fee_slashed: COD?.amount,
          delivery_fee_actual: delivery?.netAmount,
          delivery_fee_slashed: delivery?.amount,
          total_convenience_fee: total?.netAmount,
          page_type: 'order management screen'
        });
        // Segment Push event
        segmentEventPush({
          event: 'Whats This Clicked',
          action: 'Whats this click',
          category: 'order details interaction',
          fee_section_whats_this_clicked: true,
          order_id: orderResponse?.code,
          order_status: item.entryStatus,
          product_id: item?.product?.code,
          screen_name: 'order management screen'         
        });
      }
    });
  };

  onInfoClick = () => this.props.showModal('ajio-wallet-info');

  onCloseModalClick = () => this.props.hideModal('ajio-wallet-info');

  renderAjioCashInfoModal = () => {
    const {
      source,
      ajioWalletEarnData: { extraResponseParams = [] },
      newDesignLuxe,
      ajioSuperCashCartEnable = false,
      ajioSuperCashCurrencyConfig = {},
      isPageType = '',
      ajioSuperCashODPEnable = false
    } = this.props;
    const { currencyName = '' } = ajioSuperCashCurrencyConfig || {};
    const superCashName =
      (isPageType === 'orderDetails' && ajioSuperCashODPEnable) || ajioSuperCashCartEnable
        ? currencyName
        : 'SuperCash';
    const infoObj = extraResponseParams.find(item => _get(item, 'key.value') === 'walletInfo');
    const content = _get(infoObj, 'value.value');
    const modalClassName = `ajio-wallet-info ajio-wallet-info-${source}`;
    return (
      <Modal name="ajio-wallet-info" className={modalClassName} closeButton={false} show>
        <div className="ac-detail-modal">
          <div className="ac-detail-modal-header">
            <span className="ac-detail-modal-header-text">
              <strong>{superCashName}</strong>
            </span>
          </div>
          <div
            className="ac-detail-modal-content"
          >
            {newDesignLuxe
              ? "Introducing a digital wallet that helps you earn Bonus Points on every order when you shop at AJIO.com. What's more? You can also score special perks during promotions, brand days & sale events which can be redeemed for your favourite styles. T&C Apply*"
              : content}
          </div>
        </div>
        <div
          className="ac-detail-modal-action"
          onClick={this.onCloseModalClick}
          role="button"
          tabIndex={0}
          aria-label="OKAY, GOT IT"
        >
          <span className="ac-detail-modal-action-text" aria-hidden="true">
            OKAY, GOT IT
          </span>
        </div>
      </Modal>
    );
  };

  onInfoClickk = () => this.props.showModal('ajio-wallet-info1');

  onCloseModalClickk = () => {
    this.props.hideModal('ajio-wallet-info1');
    const whatsThisElement=document.getElementById('whats-this-button')
    if(whatsThisElement){
      whatsThisElement.focus()
    }
  }

  renderAjioCashInfoModalk = () => {
    const {
      source = '',
      convenienceFee = {},
      codConvenienceData = {},
      freeShippingAmountLimit = '1200',
      isConvenienceFeeEnabled,
      isThankYouPage,
      orderLevelDetail: { orderResponse = {} },
      retryPaymentPage = false,
      cart = {},
      isPriorityDeliveryFlagOn,
      enableRushDelivery
    } = this.props;

    const {
      convenienceFeeInfo = {},
      convenienceFeeNote = '',
      convenienceRefundPolicy: { readPolicyUrl = '' } = {},
      showConvenienceFeeWhatThis = ''
    } = codConvenienceData;

    const retryconvenienceFeeObj = {
      COD: { netAmount: cart?.orderSummary?.convenienceFee?.COD?.netAmount?.value || '' },
      RVP: { netAmount: cart?.orderSummary?.convenienceFee?.RVP?.netAmount?.value || '' },
      delivery: { netAmount: cart?.orderSummary?.convenienceFee?.delivery?.netAmount?.value || '' },
      total: { netAmount: cart?.orderSummary?.convenienceFee?.total?.netAmount?.value || '' }
    };

    const { code = '', entries } = orderResponse;
    const {
      COD = {},
      RVP = {},
      delivery = {},
      total = {},
      priorityDelivery = {},
      rushDelivery = {}
    } = retryPaymentPage ? retryconvenienceFeeObj : convenienceFee;
    const controlShowConvenienceFeeWhatThis = showConvenienceFeeWhatThis === 'ON';
    const modalClassName = `ajio-wallet-info1`;
    const redirectToReadPolicy = () => {
      window.location.href = readPolicyUrl;
    };
    const refundStatus = [
      COD?.isFeeCharged,
      RVP?.isFeeCharged,
      delivery?.isFeeCharged,
      isPriorityDeliveryFlagOn && priorityDelivery?.isFeeCharged,
      enableRushDelivery && rushDelivery?.isFeeCharged
    ].filter(el => el);
    const refundMsgs = [
      COD?.isFeeCharged ? 'Cash on Delivery' : '',
      RVP?.isFeeCharged ? 'Platform Fee' : '',
      delivery?.isFeeCharged ? 'Delivery Fee' : '',
      isPriorityDeliveryFlagOn && priorityDelivery?.isFeeCharged ? 'Priority Delivery Fee' : '',
      enableRushDelivery && rushDelivery?.isFeeCharged ? 'Rush Delivery Fee' : ''
    ].filter(el => el);

    const finalRefundMsg =
      refundMsgs.length === 1
        ? `${refundMsgs[0]}`
        : refundMsgs.length === 2
        ? `${refundMsgs[0]} and ${refundMsgs[1]}`
        : refundMsgs.length === 3
        ? `${refundMsgs[0]}, ${refundMsgs[1]} and ${refundMsgs[2]}`
        : refundMsgs.length === 4
        ? `${refundMsgs[0]}, ${refundMsgs[1]}, ${refundMsgs[2]} and ${refundMsgs[3]}`
        : '';

    return (
      <Modal ariaLabel="Convenience Fee" name="ajio-wallet-info1" className={modalClassName} closeButton={true} show>
        <div className="ac-detail-modal convenience_fee">
          <div className="ac-detail-modal-header">
            <div className="ac-detail-modal-header-text" role='heading' aria-level={2}>
              <strong>Convenience Fee</strong>
            </div>
          </div>
          <div>₹{Number(total?.netAmount ?? 0).toFixed(2)}</div>
        </div>
        {delivery?.netAmount && (
          <div className="convenience-fee-subcontent">
            <div>
              <div>
                <span role='heading' aria-level={3}>{convenienceFeeInfo['Delivery Fee']?.title}</span>
                <span className="refund_status">
                  {controlShowConvenienceFeeWhatThis
                    ? delivery?.isFeeCharged === undefined
                      ? ''
                      : delivery?.isFeeCharged
                      ? delivery?.isAjioFault
                        ? ' (Refundable)'
                        : ' (Non-refundable)'
                      : ' (Refundable)'
                    : ''}
                </span>
              </div>
              <div>
                {convenienceFeeInfo['Delivery Fee']?.description.replace(
                  '${amount}',
                  freeShippingAmountLimit
                )}
              </div>
            </div>
            <div>
              {Number(delivery?.netAmount ?? 0) === 0
                ? 'FREE'
                : `₹${Number(delivery?.netAmount ?? 0).toFixed(2)}`}{' '}
            </div>
          </div>
        )}

        {RVP?.netAmount && (
          <div className="convenience-fee-subcontent">
            <div>
              <div>
                <span role='heading' aria-level={3}>{convenienceFeeInfo['Platform Convenience Fee']?.title}</span>
                <span className="refund_status">
                  {controlShowConvenienceFeeWhatThis
                    ? RVP?.isFeeCharged === undefined
                      ? ''
                      : RVP?.isFeeCharged
                      ? RVP?.isAjioFault
                        ? ' (Refundable)'
                        : ' (Non-refundable)'
                      : ' (Refundable)'
                    : ''}
                </span>
              </div>
              <div>{convenienceFeeInfo['Platform Convenience Fee']?.description}</div>
            </div>
            <div>
              {Number(RVP?.netAmount ?? 0) === 0
                ? 'FREE'
                : `₹${Number(RVP?.netAmount ?? 0).toFixed(2)}`}
            </div>
          </div>
        )}

        {COD?.netAmount && (
          <div className="convenience-fee-subcontent">
            <div>
              <div>
                <span role='heading' aria-level={3}>{convenienceFeeInfo['COD Convenience Fee']?.title}</span>
                <span className="refund_status">
                  {controlShowConvenienceFeeWhatThis
                    ? COD?.isFeeCharged === undefined
                      ? ''
                      : COD?.isFeeCharged
                      ? COD?.isAjioFault
                        ? ' (Refundable)'
                        : ' (Non-refundable)'
                      : ' (Refundable)'
                    : ''}
                </span>
              </div>
              <div>{convenienceFeeInfo['COD Convenience Fee']?.description}</div>
            </div>
            <div>
              {Number(COD?.netAmount ?? 0) === 0
                ? 'FREE'
                : `₹${Number(COD?.netAmount ?? 0).toFixed(2)}`}
            </div>
          </div>
        )}

        {enableRushDelivery && rushDelivery?.netAmount ? (
          <div className="convenience-fee-subcontent">
            <div>
              <div>
                {convenienceFeeInfo['Rush Delivery Fee']?.title}
                <span className="refund_status">
                  {controlShowConvenienceFeeWhatThis
                    ? rushDelivery?.isFeeCharged === undefined
                      ? ''
                      : rushDelivery?.isFeeCharged
                      ? rushDelivery?.isAjioFault
                        ? ' (Refundable)'
                        : ' (Non-refundable)'
                      : ' (Refundable)'
                    : ''}
                </span>
              </div>
              <div>{convenienceFeeInfo['Rush Delivery Fee']?.description}</div>
            </div>
            <div>
                  {
                  rushDelivery?.amount && rushDelivery?.amount > rushDelivery?.netAmount ?
                    <span className="rushPDFeeChangeContainerClass">
                      <RupeeSymbol />
                      {`${Number(rushDelivery.netAmount || rushDelivery.netAmount.value).toFixed(2)}`}
                      <span className="rushPDFeeChangeSubClass">
                        <RupeeSymbol />
                        {`${Number(rushDelivery.amount || rushDelivery.amount.value).toFixed(2)}`}
                      </span>
                    </span>
                    :
                  <>
                    {Number(rushDelivery?.netAmount ?? 0) === 0
                      ? 'FREE'
                      : `₹${Number(rushDelivery?.netAmount ?? 0).toFixed(2)}`}
                  </>
                  }
            </div>
          </div>
        ) : isPriorityDeliveryFlagOn && priorityDelivery?.netAmount ? (
          <div className="convenience-fee-subcontent">
            <div>
              <div>
                {convenienceFeeInfo['Priority Delivery Fee']?.title}
                <span className="refund_status">
                  {controlShowConvenienceFeeWhatThis
                    ? priorityDelivery?.isFeeCharged === undefined
                      ? ''
                      : priorityDelivery?.isFeeCharged
                      ? priorityDelivery?.isAjioFault
                        ? ' (Refundable)'
                        : ' (Non-refundable)'
                      : ' (Refundable)'
                    : ''}
                </span>
              </div>
              <div>{convenienceFeeInfo['Priority Delivery Fee']?.description}</div>
            </div>
            <div>
              {Number(priorityDelivery?.netAmount ?? 0) === 0
                ? 'FREE'
                : `₹${Number(priorityDelivery?.netAmount ?? 0).toFixed(2)}`}
            </div>
          </div>
        ) : null}

        {controlShowConvenienceFeeWhatThis && refundStatus.length > 0 && (
          <div className="final_refund-msg">
            <p>
              In case you return any product, {finalRefundMsg} will not be refunded{' '}
              <span onClick={redirectToReadPolicy}>Read policy</span>
            </p>
          </div>
        )}

        {isConvenienceFeeEnabled && !controlShowConvenienceFeeWhatThis && (
          <div className="convenience-fee-msg">
            <span dangerouslySetInnerHTML={{ __html: convenienceFeeNote }} />
            <span className="readPolicy" onClick={redirectToReadPolicy}>
              Read policy.
            </span>
          </div>
        )}
        <div
          role="button"
          className="ac-detail-modal-action"
          onClick={this.onCloseModalClickk}
          tabIndex={0}
        >
          <span className="ac-detail-modal-action-text">
            Okay
          </span>
        </div>
      </Modal>
    );
  };

  handleClickWhatsThis = (isShippingPage, newDesignLuxe) => {
    gtmEventPush({
      event: 'whats_this_click',
      event_category: isShippingPage
        ? 'shipping interactions'
        : 'bag interactions',
      event_action: 'Whats this click',
      store_type: newDesignLuxe ? 'luxe' : 'ajio',
      page_type: isShippingPage ? 'shipping screen' : 'bag screen',
    });
    this.props.showModal('convenience-info');
  };

  render() {
    let {
      cart = {},
      showCredits = false,
      source,
      returnInfoUrl = '',
      isPageType = '',
      awEarnAmount = 0,
      showAjioCash = true,
      ajioWalletEarnData: { extraResponseParams = [] } = {},
      device = '',
      newDesignLuxe,
      orderConfirmPage,
      retryPaymentPage,
      isShippingPage,
      showModal,
      codConvenienceData,
      isConvenienceFeeEnabled,
      giftItem = [],
      isPaymentModesOnOrderPlacementFlag,
      hideModal,
      ajioSuperCashCartEnable = false,
      ajioSuperCashCartConfig = {},
      ajioSuperCashCurrencyConfig = {},
      displayAjioWallet = false,
      ajioSuperCashODPEnable = false,
      memberShipStaticValues,
      enableAjioMemberShipProgram,
      ajioMembershipConfig,
      membershipBenefitResponse,
    } = this.props;
    const {
      orderLevelDetail,
      enableGiftWithProduct,
      giftWithProductConfig: { odpSummary = '' } = {}
    } = this.props;
    const { currencyName = '' } = ajioSuperCashCurrencyConfig || {};
    const superCashName =
      (isPageType === 'orderDetails' && ajioSuperCashODPEnable) || ajioSuperCashCartEnable
        ? currencyName
        : 'SuperCash';
    const {
      orderResponse: {
        isConvenienceFeeRefundable = '',
        confirmedEntries = [],
        cancelledEntries = [],
        consignmentsData = [],
        paymentMode: hybrisPaymentMode = '',
        optedPaymentModeOrderList = [],
        code = '',
        emiOfferDetails: { noCostEmiDiscount = 0} = {},
      } = {}
    } = orderLevelDetail;
    const { convenienceFeeInfo = {} } = codConvenienceData;
    const constantConvenience = {
      delivery: convenienceFeeInfo['Delivery Fee']?.title ?? 'Delivery Fee',
      RVP: convenienceFeeInfo['Platform Convenience Fee']?.title ?? 'Platform Fee',
      COD: convenienceFeeInfo['COD Convenience Fee']?.title ?? 'COD Fee',
      PriorityDelivery: convenienceFeeInfo['Priority Delivery Fee']?.title ?? 'Priority Delivery Fee',
      RushDelivery: convenienceFeeInfo['Rush Delivery Fee']?.title ?? 'Rush Delivery Fee'
    };
    const constantConvenienceRefundStatus = {
      REFUNDABLE: 'Refundable',
      NON_REFUNDABLE: 'Non-refundable',
      PARTIAL_REFUNDABLE: 'Partially refundable'
    };
    const {
      showCodConvenienceFeeFlow = 'OFF',
      showConvenienceFeeWhatThis = ''
    } = codConvenienceData;
    const controlShowConvenienceFeeWhatThis = showConvenienceFeeWhatThis === 'ON';
    const showConvenienceFeeFlow = getShowCodConvenienceFlowFlag(showCodConvenienceFeeFlow);

    const getPriceStripped = (price = '') => price.slice(3).trim();

    const {
      orderSummary: {
        bagTotal: { formattedValue: bagTotalAmt = '' } = {},
        bagDiscount: { formattedValue: bagDiscountAmt = '', value: bagDiscountValue = 0 } = {},
        orderTotal: { formattedValue: orderTotalAmt = '', value: orderValue = 0 } = {},
        deliveryCharge: { formattedValue: deliveryAmt = '', value: deliveryValue = 0 } = {},
        exclusiveGSTCharge: {
          formattedValue: exclusiveGSTAmt = '',
          value: exclusiveGSTCharge = 0
        } = {},
        promoSaving: { formattedValue: promoSavingAmt = '' } = {},
        couponSaving: { formattedValue: couponSavingAmt = '' } = {},
        giftWrapCharge: { formattedValue: giftWrapAmt = '' } = {},
        storeCredit: { formattedValue: storeCreditRedeemed = '', value: creditRedeemed = 0 } = {},
        jioPrimePoint: {
          formattedValue: jioPrimePointsRedeemed = '',
          value: primePointRedeemed = 0
        } = {},
        bankDiscount: { formattedValue: OfferBankDiscount = '', value: bankDiscount = 0 } = {},
        loyaltyBurnedPoints: {
          formattedValue: loyaltyBurnedPoints = '',
          value: loyaltyBurnedPointValue = 0
        } = {},
        relianceOneAmount: {
          formattedValue: relianceOneAmount = '',
          value: relianceOneAmountValue = 0
        } = {},
        redeemedMahaCachBack = 0,
        convenienceFee = {}
      } = {},
      orderSummary = {},
      paymentMode = '',
      giftRecepientName = '',
      giftSenderName = '',
      balancedPaidModeVia = '',
      membershipSavings = {},
      emiOfferDetails: { noCostEmiDiscount: noCostEmiDiscountTY = 0 } = {}
    } = cart;
     console.log("membershipSavings", cart)
    const { RVP = {}, COD = {}, delivery = {}, total = {} } = convenienceFee;
    const showGiftWrap = giftWrapAmt && giftRecepientName && giftSenderName;
    const { value: { value: thresholdValue } = {} } =
      extraResponseParams.find(({ key: { value } }) => value === 'minimumEarnThreshold') || {};
    let pointValue;
    if (thresholdValue) {
      pointValue = thresholdValue - (orderValue - deliveryValue - exclusiveGSTCharge);
    }
    const {
      EVENT_ACTION,
      EVENT_CATEGORY,
      LABELS: { WHAT_IS_AJIO_WALLET }
    } = AjioWalletEventConstants;
    awEarnAmount = awEarnAmount || this.props.ajioWalletEarnData.eligibleEarnAmount;
    let amountPaid = '0';
    amountPaid = `${Math.abs(
      (orderValue || 0) -
        (creditRedeemed || 0) -
        Math.abs(bankDiscount || 0) -
        Math.abs(
          typeof loyaltyBurnedPoints === 'number'
            ? loyaltyBurnedPoints
            : loyaltyBurnedPoints.value || 0
        ) -
        Math.abs(relianceOneAmountValue || 0) -
        Math.abs(redeemedMahaCachBack || 0)
    ).toFixed(2)}`;

    // NOTE: FOR GIFT WITH PURCHASE
    const [consignmentObj = {}] = consignmentsData;
    const { entries: consignedEntries = [], returnRequests = [] } = consignmentObj;

    let giftCount = 0;
    if (enableGiftWithProduct) {
      const confirmedEntriesCount = confirmedEntries.reduce((acc, cur) => {
        if (cur?.entry?.isGiftProduct) acc += cur.entry.quantity;
        return acc;
      }, 0);

      const cancelledEntriesCount = cancelledEntries.reduce((acc, cur) => {
        if (cur?.entry?.isGiftProduct) acc += cur.entry.quantity;
        return acc;
      }, 0);

      const deliveredEntriesCount = consignedEntries.reduce((acc, cur) => {
        if (cur?.orderEntry?.isGiftProduct) acc += cur.orderEntry.quantity;
        return acc;
      }, 0);

      const returnedEntriesCount = returnRequests.reduce((acc, cur) => {
        let reqCount = 0;
        if(cur?.returnEntries && Array.isArray(cur?.returnEntries)){
          reqCount = cur?.returnEntries.reduce((acc1, cur1) => {
            if (cur1?.entry?.isGiftProduct) acc1 += cur1?.entry?.quantity;
            return acc1;
          }, 0);
        }
       
        return acc + reqCount;
      }, 0);

      giftCount =
        confirmedEntriesCount +
        cancelledEntriesCount +
        deliveredEntriesCount +
        returnedEntriesCount;
    }

    const {
      AJIO_FIRST_MEMBERSHIP_DISCOUNT_TEXT
    } = SubscriptionStaticKeys;


    if (isPageType === 'orderDetails') {
      return (
        <div
          className={`${
            isPaymentModesOnOrderPlacementFlag
              ? 'order-summary-container-no-bg'
              : 'order-summary-container'
          }`}
        >
          {showAjioCash && pointValue !== undefined && (
            <div className="ajio-wallet-earn-section">
              {pointValue > 0 && (
                <div className="ac-earn-details">
                  Shop for{' '}
                  <strong>
                    {awConstants.AW_RUPEE_SYMBOL}
                    {parseFloat(pointValue).toFixed(2)}
                  </strong>{' '}
                  {`more to earn ${superCashName} in your Ajio Wallet.`}
                </div>
              )}
              {pointValue <= 0 && parseInt(awEarnAmount, 10) >= 1 && (
                <div className="ac-earn-details">
                  Earn{' '}
                  <strong>
                    {awConstants.AW_RUPEE_SYMBOL}
                    {parseFloat(awEarnAmount).toFixed(2)}
                  </strong>{' '}
                  {`${superCashName} on this order`}
                </div>
              )}
              {pointValue !== undefined && (
                <div
                  className="ac-about-link"
                  data-ga-event-category={EVENT_CATEGORY}
                  data-ga-event-action={EVENT_ACTION}
                  data-ga-event-label={WHAT_IS_AJIO_WALLET.replace('SuperCash', superCashName)}
                  onClick={this.onInfoClick}
                  tabIndex={0}
                  role="button"
                >
                  <span>{newDesignLuxe ? `What is ${superCashName}?` : `What is ${superCashName}?`}</span>
                </div>
              )}
            </div>
          )}
          <div className="order-summary product-card" id="orderSummary">
            {source === 'mobile' ? (
              <div className="cardheader bold-font">
                <strong>{this.textContent.orderSummary}</strong>
              </div>
            ) : (
              ''
            )}
            {source === 'desktop' ? (
              <section className="price-summary  border-bottom" id="orderTotalFull">
                <span className="label bold-font" role='heading' aria-level={2}>
                  {this.textContent.orderDetails}
                </span>
              </section>
            ) : (
              ''
            )}

            {
              <section className="price-summary" id="bagTotal">
                <span className="label">
                  {this.textContent.orderAmount}{' '}
                  {enableGiftWithProduct && giftCount > 0 ? odpSummary : ''}
                </span>
                <span className="price-value">{displayValueWithSymbol(bagTotalAmt)}</span>
              </section>
            }

            {bagDiscountValue > 0 && (
              <section className="price-summary" id="bagDiscount">
                <span className="label">
                  {this.textContent.orderSavings}
                </span>
                <span className="price-value discount-price">
                  {displayValueWithSymbol(bagDiscountAmt)}
                </span>
              </section>
            )}
            {orderSummary.hasOwnProperty('couponSaving') && couponSavingAmt != '' ? (
              <section className="price-summary" id="couponDiscount">
                <span className="label">
                  {this.textContent.couponSaving}
                </span>
                <span className="price-value discount-price">
                  {displayValueWithSymbol(couponSavingAmt)}
                </span>
              </section>
            ) : (
              ''
            )}
            {orderSummary.hasOwnProperty('promoSaving') && promoSavingAmt != '' ? (
              <section className="price-summary" id="promoDiscount">
                <span className="label">
                  {this.textContent.promoSaving}
                </span>
                <span className="price-value discount-price">
                  {displayValueWithSymbol(promoSavingAmt)}
                </span>
              </section>
            ) : (
              ''
            )}
            {enableAjioMemberShipProgram &&
            membershipSavings?.membershipDiscount > 0 ? (
              <section className="price-summary" id="membershipDiscount">
                <span
                  className="label"
                >
                  {memberShipStaticValues?.[AJIO_FIRST_MEMBERSHIP_DISCOUNT_TEXT]}
                </span>
                <span className="price-value discount-price">
                  <RupeeSymbol />
                  {membershipSavings?.membershipDiscount}
                </span>
              </section>
            ) : null}
            {/* for testing purpose only if codConvenienceData will not come */}
            {/* <div onClick={this.onInfoClickk}>
                            <span className="whats-this-info">{this.textContent.whatsThis}</span>
                        </div>       */}
            {showConvenienceFeeFlow && (
              <section className="price-summary" id="delivery">
                <p className="label" >
                  {this.textContent.convenienceFee} &nbsp;
                </p>
                <p
                  style={{ color: '#866528' }}
                  className="price-value"
                >
                  {
                    parseInt(total?.netAmount) > 0
                      ? displayValueWithSymbol(parseInt(total?.netAmount))
                      : deliveryValue > 0
                      ? displayValueWithSymbol(deliveryAmt)
                      : 'FREE'
                  }
                </p>
                {parseInt(total?.netAmount) > 0 ? (
                  <span
                    tabIndex={0}
                    role="button"
                    className="whats-this"
                    onClick={() => {
                      this.onInfoClickk();
                      this.gaEventsCodConvenience();
                      this.setState({ feeExplanation: true });
                    }}
                    id="whats-this-button"
                  >
                    {this.textContent.whatsThis}
                  </span>
                ) : (
                  ''
                )}
                {/* TODO: add isConvenienceFeeEnabled flag */}
                {controlShowConvenienceFeeWhatThis && isConvenienceFeeRefundable ? (
                  <div>
                    <span className="label nonRefundable">
                      ({constantConvenienceRefundStatus[isConvenienceFeeRefundable]})
                    </span>
                  </div>
                ) : (
                  isConvenienceFeeEnabled &&
                  parseInt(total?.netAmount) > 0 && (
                    <div>
                      <span className="label nonRefundable">(Non-refundable)</span>
                    </div>
                  )
                )}
              </section>
            )}
            {/* convenienceFee['total'].netAmount > 0 ?  displayValueWithSymbol(deliveryAmt) : "FREE" */}
            {orderSummary.hasOwnProperty('exclusiveGSTCharge') && exclusiveGSTAmt != '' ? (
              <section className="price-summary" id="estimatedGst">
                <span className="label">
                  {this.textContent.estimatedGst}
                </span>
                <span className="price-value">{displayValueWithSymbol(exclusiveGSTAmt)}</span>
              </section>
            ) : (
              ''
            )}
            {orderSummary.hasOwnProperty('giftWrapCharge') && giftWrapAmt != '' && showGiftWrap ? (
              <section className="price-summary" id="promoDiscount">
                <span className="label" >
                  {this.textContent.giftWrap}
                </span>
                <span className="price-value">{displayValueWithSymbol(giftWrapAmt)}</span>
              </section>
            ) : (
              ''
            )}
            {
              <section className="price-summary" id="orderTotal">
                <span className="label">
                  {this.textContent.orderTotal}
                </span>
                <span className="price-value">{displayValueWithSymbol(orderTotalAmt)}</span>
              </section>
            }
            {orderSummary.hasOwnProperty('bankDiscount') && OfferBankDiscount != '' ? (
              <section className="price-summary" id="orderTotal">
                <span className="label">
                  {this.textContent.bankDiscount}
                </span>
                <span className="price-value discount-price">
                  {displayValueWithSymbol(Math.abs(bankDiscount)?.toFixed(2))}
                </span>
              </section>
            ) : (
              ''
            )}
            {noCostEmiDiscount > 0 ? (
              <section className="price-summary" id="orderTotal">
                <span className="label">{this.textContent.noCostEmiDiscount}</span>
                <span className="price-value discount-price">
                  {' '}
                  {displayValueWithSymbol(Math.abs(noCostEmiDiscount)?.toFixed(2))}
                </span>
              </section>
            ) : (
              ''
            )}
            {(orderSummary.hasOwnProperty('bankDiscount') && OfferBankDiscount !== '') ||
            noCostEmiDiscount > 0 ? (
              <section className="price-summary" id="orderTotal">
                <span className="label bold-font">
                  {this.textContent.amountPayable}
                </span>
                <span className="price-value bold-font">
                  {displayValueWithSymbol(Math.abs(orderValue - Math.abs(bankDiscount) - Math.abs(noCostEmiDiscount)).toFixed(2))}
                </span>
              </section>
            ) : (
              ''
            )}
            {!showConvenienceFeeFlow && (
              <section className="price-summary" id="delivery">
                <span className="label">
                  {this.textContent.delivery}
                </span>
                <span className="price-value">
                  {deliveryValue > 0 ? displayValueWithSymbol(deliveryAmt) : 'FREE'}
                </span>
              </section>
            )}
            {
              <>
                <div className="divider">
                  <Divider />
                </div>
                <div className="paymentMode" aria-label={this.textContent.paymentMode} role='heading' aria-level={3}>
                  {this.textContent.paymentMode}
                </div>
              </>
            }
            {!isPaymentModesOnOrderPlacementFlag || optedPaymentModeOrderList?.length === 0 ? (
              <>
                {orderSummary.hasOwnProperty('storeCredit') &&
                storeCreditRedeemed != '' &&
                showCredits ? (
                  <section className="price-summary" id="orderTotal">
                    <span className="label">
                      {this.textContent.storeCredit}
                    </span>
                    <span className="price-value">{storeCreditRedeemed}</span>
                  </section>
                ) : (
                  ''
                )}
                {orderSummary.hasOwnProperty('loyaltyBurnedPoints') &&
                loyaltyBurnedPointValue != 0 ? (
                  <section className="price-summary" id="orderTotal">
                    <span className="label">
                      {this.textContent.loyaltyPoints}
                    </span>
                    <span className="price-value discount-price">
                      {displayValueWithSymbol(Math.abs(loyaltyBurnedPoints))}
                    </span>
                  </section>
                ) : (
                  ''
                )}
                {orderSummary.hasOwnProperty('relianceOneAmount') && relianceOneAmount != '' ? (
                  <section className="price-summary " id="orderTotal">
                    <span
                      className="label order-total-normal-font"
                    >
                      {this.textContent.relianceOneAmount}
                    </span>
                    <span className="price-value order-total-normal-font">
                      {displayValueWithSymbol(relianceOneAmountValue)}
                    </span>
                  </section>
                ) : (
                  ''
                )}
                {orderSummary.hasOwnProperty('redeemedMahaCachBack') &&
                redeemedMahaCachBack != 0 ? (
                  <section className="price-summary " id="orderTotal">
                    <span
                      className="label order-total-normal-font"
                    >
                      {this.textContent.redeemedMahaCachBack}
                    </span>
                    <span className="price-value order-total-normal-font">
                      {displayValueWithSymbol(redeemedMahaCachBack.toFixed(2))}
                    </span>
                  </section>
                ) : (
                  ''
                )}
                {orderSummary.hasOwnProperty('jioPrimePoint') &&
                jioPrimePointsRedeemed != '' &&
                showCredits ? (
                  <section className="price-summary" id="orderTotal">
                    <span className="label">
                      {this.textContent.jioPrimePoint}
                    </span>
                    <span className="price-value">{jioPrimePointsRedeemed}</span>
                  </section>
                ) : (
                  ''
                )}
                {Boolean(parseInt(amountPaid)) &&
                balancedPaidModeVia &&
                balancedPaidModeVia !== '' ? (
                  <section className="price-summary" id="orderTotal">
                    <span
                      className="label bold-font"
                    >
                      {balancedPaidModeVia.toLowerCase() === this.textContent.COD.toLowerCase()
                        ? this.textContent.COD
                        : hybrisPaymentMode}
                    </span>
                    <span className="price-value bold-font">
                      {displayValueWithSymbol(amountPaid)}
                    </span>
                  </section>
                ) : (
                  ''
                )}
                {orderSummary.hasOwnProperty('jioPrimePoint') &&
                jioPrimePointsRedeemed != '' &&
                showCredits ? (
                  <section className="price-summary" id="orderTotal">
                    <span className="label bold-font">
                      {this.textContent.amountToBePaid}
                    </span>
                    <span className="price-value bold-font">
                      {displayValueWithSymbol(Math.abs(orderValue - primePointRedeemed).toFixed(2))}
                    </span>
                  </section>
                ) : (
                  ''
                )}
              </>
            ) : (
              <>
                <OrderSummaryWithMOPs
                  optedPaymentModeOrderList={optedPaymentModeOrderList}
                  code={code}
                  orderStatus={this.state?.orderStatus}
                />
              </>
            )}
            {source === 'mobile' ? (
              <section className="price-summary  border-top" id="orderTotalFull">
                <span className="label bold-font">
                  {this.textContent.orderTotal}
                </span>
                <span className="price-value bold-font">
                  {displayValueWithSymbol(orderTotalAmt)}
                </span>
              </section>
            ) : (
              ''
            )}

            {source === 'desktop' ? (
              <div className="return-info-link">
                <div className="status-ic ic-return" />
                <a href={returnInfoUrl}>
                  Return Information
                </a>
              </div>
            ) : (
              ''
            )}
            {this.renderAjioCashInfoModal()}
            {this.renderAjioCashInfoModalk()}
          </div>
        </div>
      );
    }

    return (
      <div className="order-summary-container">
        {displayAjioWallet && showAjioCash && pointValue !== undefined && device !== 'mobile' && (
            <div className="ajio-wallet-earn-section">
              {pointValue > 0 && (
                <div
                  className="ac-earn-details"
                  aria-label={`Shop for ${parseFloat(pointValue).toFixed(
                    2
                  )} more to earn ${superCashName} in your Ajio Wallet.`}
                >
                  Shop for{' '}
                  <strong>
                    {awConstants.AW_RUPEE_SYMBOL}
                    {parseFloat(pointValue).toFixed(2)}
                  </strong>{' '}
                  more to earn {superCashName} in your Ajio Wallet.
                </div>
              )}
              {pointValue <= 0 && parseInt(awEarnAmount, 10) >= 1 && (
                <div
                  className="ac-earn-details"
                  aria-label={`Earn ${parseFloat(awEarnAmount).toFixed(
                    2
                  )} ${superCashName} on this order`}
                >
                  Earn{' '}
                  <strong>
                    {awConstants.AW_RUPEE_SYMBOL}
                    {parseFloat(awEarnAmount).toFixed(2)}
                  </strong>{' '}
                  {superCashName} on this order
                </div>
              )}
              {pointValue !== undefined && (
                <div
                  className="ac-about-link"
                  data-ga-event-category={EVENT_CATEGORY}
                  data-ga-event-action={EVENT_ACTION}
                  data-ga-event-label={WHAT_IS_AJIO_WALLET.replace('SuperCash', superCashName)}
                  onClick={this.onInfoClick}
                  tabIndex={0}
                >
                  <span aria-label={`What is ${superCashName}?`}>
                    What is {superCashName}?
                  </span>
                </div>
              )}
            </div>
          )}

        {/* NOTE: FOR AJIO SUPER CASH */}
        {ajioSuperCashCartEnable && (
          <AjioSuperCash
            ajioSuperCashCartConfig={ajioSuperCashCartConfig}
            ajioSuperCashCurrencyConfig={ajioSuperCashCurrencyConfig}
            showModal={showModal}
            hideModal={hideModal}
          />
        )}

        <div className="order-summary product-card" id="orderSummary">
          <div className="cardheader bold-font" role='heading' aria-level={2}>
            <strong>{this.textContent.orderSummary}</strong>
          </div>
          <section className="price-summary" id="bagTotal">
            <span className="label">
              {this.textContent.bagTotal}
              <span style={{ paddingLeft: '5px' }}>
                {enableGiftWithProduct && giftItem?.length > 0 ? odpSummary : ''}
              </span>
            </span>
            <span className="price-value">{displayValueWithSymbol(bagTotalAmt)}</span>
          </section>

          {bagDiscountValue > 0 && (
            <section className="price-summary" id="bagDiscount">
              <span
                className="label"
              >
                {this.props.newDesignLuxe ? 'Bag Savings' : this.textContent.bagDiscount}
              </span>
              <span className="price-value discount-price">
                {displayValueWithSymbol(bagDiscountAmt)}
              </span>
            </section>
          )}
          {/* TODO: Recheck */}
          {retryPaymentPage && showConvenienceFeeFlow && (
            <section className="price-summary" id="delivery">
              <p className="label">
                {this.textContent.convenienceFee} &nbsp;
              </p>
              <p className="price-value">
                {total?.netAmount?.value > 0
                  ? displayValueWithSymbol(total.netAmount.formattedValue)
                  : 'FREE'}
              </p>
              <div onClick={this.onInfoClickk}>
                <span
                  tabIndex={0}
                  role="button"
                  className="whats-this-info"
                  id="whats-this-button"
                >
                  {this.textContent.whatsThis}
                </span>
              </div>
            </section>
          )}
          {orderConfirmPage && showConvenienceFeeFlow && (
            <section className="price-summary" id="delivery">
              <p className="label">
                {this.textContent.convenienceFee}
              </p>
              <p className="price-value">
                {deliveryValue > 0 ? displayValueWithSymbol(deliveryAmt) : 'Free'}
              </p>
            </section>
          )}
          {!(orderConfirmPage || retryPaymentPage) &&
            Object.keys(convenienceFee?.total || {}).length > 0 &&
            showConvenienceFeeFlow && (
              <section className="price-summary convenience-summary" id="bagDiscount">
                <span className="label convenienceFeeInfoHeading">
                  Convenience Fee{' '}
                </span>
                <span
                  tabIndex={0}
                  role="button"
                  aria-label="What's this Convenience fee?"
                  className={`${
                    this.props.newDesignLuxe ? 'desktopConvenienceFeeInfo' : 'convenienceFeeInfo'
                  }`}
                  onClick={() => {
                    this.handleClickWhatsThis(isShippingPage, newDesignLuxe);
                  }}
                  onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                      event.preventDefault();
                      setTimeout(() => {
                        this.handleClickWhatsThis(isShippingPage, newDesignLuxe);
                      }, 0);
                    }
                  }}
                >
                  What's this?
                </span>
                {Object.keys(convenienceFee || {}).map(item => {
                  const convenienceFeeData = convenienceFee[item];
                  if (
                    Object.keys(convenienceFeeData || {}).length &&
                    item !== 'total' &&
                    item !== 'COD'
                  ) {
                    const { amount = {}, netAmount = {} } = convenienceFeeData;
                    // if (item === 'RVP' && netAmount?.value === 0) return;
                    return (
                      <div 
                        className="convenience-fee-summary"
                      >
                        <span
                          className={`${
                            this.props.newDesignLuxe
                              ? 'luxeConvenienceFeeSummaryHeading'
                              : 'convenienceFeeSummaryHeading'
                          }`}
                        >
                          {constantConvenience[item]}
                        </span>
                        <span 
                          className="price-value convenienceFeeSummaryPrice"
                        >
                          {netAmount?.value >  0 ? (
                          <>
                          {netAmount?.value < amount?.value ? <div className="membership-platform-fee"><div>{displayValueWithSymbol(netAmount.formattedValue)}</div><span>{displayValueWithSymbol(amount.formattedValue)}</span></div> : displayValueWithSymbol(netAmount.formattedValue)
                          }
                          </>
                          ) : (
                            <div className="freeConvenienceBox">
                              <span
                                className={
                                  this.props.newDesignLuxe
                                    ? 'luxeFreeConvenience'
                                    : 'freeConvenience'
                                }
                                style={{ textDecoration: 'none' }}
                              >
                                Free
                              </span>
                                {item !== 'PriorityDelivery' && item !== 'RushDelivery' && amount?.value > 0 ?
                                  <span aria-label={`${displayValueWithSymbol(amount.formattedValue)} strike off`}>
                                    <span className="desktopFreeConveniencePrice" aria-hidden="true" >
                                      {displayValueWithSymbol(amount.formattedValue)}
                                    </span>
                                  </span> : null}
                            </div>
                          )}
                        </span>
                      </div>
                    );
                  }
                })}
              </section>
            )}
          {enableAjioMemberShipProgram &&
            (ajioMembershipConfig?.isEnableForCart ||
              ajioMembershipConfig?.isEnableForSPC ||
              ajioMembershipConfig?.isEnableForThankyou)  && (
              <>
                {membershipSavings?.membershipDiscount > 0 ? (
                  <section
                    className={this.props.newDesignLuxe ? 'luxe-price-summary' : 'price-summary'}
                    id="membershipDiscount"
                  >
                    <span
                      className="label"
                    >
                      {memberShipStaticValues?.[AJIO_FIRST_MEMBERSHIP_DISCOUNT_TEXT]}
                    </span>
                    <span className="price-value discount-price">
                      {displayValueWithSymbol(membershipSavings?.membershipDiscount?.toFixed(2))}
                    </span>
                  </section>
                ) : null}
              </>
            )}
          {orderSummary.hasOwnProperty('promoSaving') && promoSavingAmt != '' ? (
            <section className="price-summary" id="promoDiscount">
              <span className="label">
                {this.textContent.promoSaving}
              </span>
              <span className="price-value discount-price">
                {displayValueWithSymbol(promoSavingAmt)}
              </span>
            </section>
          ) : (
            ''
          )}
          {orderSummary.hasOwnProperty('couponSaving') && couponSavingAmt != '' ? (
            <section className="price-summary" id="couponDiscount">
              <span className="label">
                {this.textContent.couponSaving}
              </span>
              <span className="price-value discount-price">
                {displayValueWithSymbol(couponSavingAmt)}
              </span>
            </section>
          ) : (
            ''
          )}
          {orderSummary.hasOwnProperty('exclusiveGSTCharge') && exclusiveGSTAmt != '' ? (
            <section className="price-summary" id="estimatedGst">
              <span className="label">
                {this.textContent.estimatedGst}
              </span>
              <span className="price-value">{displayValueWithSymbol(exclusiveGSTAmt)}</span>
            </section>
          ) : (
            ''
          )}
          {orderSummary.hasOwnProperty('giftWrapCharge') && giftWrapAmt != '' && showGiftWrap ? (
            <section className="price-summary" id="promoDiscount">
              <span className="label" >
                {this.textContent.giftWrap}
              </span>
              <span className="price-value">{displayValueWithSymbol(giftWrapAmt)}</span>
            </section>
          ) : (
            ''
          )}
          {!showConvenienceFeeFlow && (
            <section className="price-summary" id="delivery">
              <span className="label">
                {this.textContent.delivery}
              </span>
              {this.props.newDesignLuxe ? (
                <span className="price-value">
                  {deliveryValue > 0 ? displayValueWithSymbol(deliveryAmt) : 'Free'}
                </span>
              ) : (
                <span className="price-value">
                  {deliveryValue > 0 ? displayValueWithSymbol(deliveryAmt) : 'FREE'}
                </span>
              )}
            </section>
          )}
          <section className="price-summary" id="orderTotal">
            <span className="label bold-font">
              {this.textContent.orderTotal}
            </span>
            <span className="price-value bold-font">{displayValueWithSymbol(orderTotalAmt)}</span>
          </section>
          {orderSummary.hasOwnProperty('storeCredit') &&
          storeCreditRedeemed != '' &&
          showCredits ? (
            <section className="price-summary " id="orderTotal">
              <span
                className="label order-total-normal-font"
              >
                {this.textContent.storeCredit}
              </span>
              <span className="price-value discount-price order-total-normal-font">
                {storeCreditRedeemed}
              </span>
            </section>
          ) : (
            ''
          )}
          {orderSummary.hasOwnProperty('loyaltyBurnedPoints') && loyaltyBurnedPointValue != 0 ? (
            <section className="price-summary" id="orderTotal">
              <span className="label">
                {this.textContent.loyaltyPoints}
              </span>
              <span className="price-value discount-price">
                {displayValueWithSymbol(Math.abs(loyaltyBurnedPoints))}
              </span>
            </section>
          ) : (
            ''
          )}
          {orderSummary.hasOwnProperty('relianceOneAmount') && relianceOneAmount != '' ? (
            <section className="price-summary " id="orderTotal">
              <span
                className="label order-total-normal-font"
              >
                {this.textContent.relianceOneAmount}
              </span>
              <span className="price-value discount-price order-total-normal-font">
                {displayValueWithSymbol(relianceOneAmount)}
              </span>
            </section>
          ) : (
            ''
          )}
          {orderSummary.hasOwnProperty('redeemedMahaCachBack') && redeemedMahaCachBack != 0 ? (
            <section className="price-summary " id="orderTotal">
              <span
                className="label order-total-normal-font"
              >
                {this.textContent.redeemedMahaCachBack}
              </span>
              <span className="price-value discount-price order-total-normal-font">
                {displayValueWithSymbol(redeemedMahaCachBack.toFixed(2))}
              </span>
            </section>
          ) : (
            ''
          )}
          {orderSummary.hasOwnProperty('bankDiscount') && OfferBankDiscount != '' ? (
            <section className="price-summary" id="orderTotal">
              <span
                className="label order-total-normal-font"
              >
                {this.textContent.bankDiscount}
              </span>
              <span className="price-value discount-price order-total-normal-font">
                {displayValueWithSymbol(Math.abs(bankDiscount))}
              </span>
            </section>
          ) : (
            ''
          )}
          {noCostEmiDiscountTY > 0 ? (
            <section className="price-summary" id="orderTotal">
              <span className="label order-total-normal-font">
                {this.textContent.noCostEmiDiscount}
              </span>
              <span className="price-value discount-price order-total-normal-font">
                {' '}
                {displayValueWithSymbol(Math.abs(noCostEmiDiscountTY)?.toFixed(2))}
              </span>
            </section>
          ) : (
            ''
          )}
          {orderSummary.hasOwnProperty('jioPrimePoint') &&
          jioPrimePointsRedeemed != '' &&
          showCredits ? (
            <section className="price-summary" id="orderTotal">
              <span className="label">
                {this.textContent.jioPrimePoint}
              </span>
              <span className="price-value discount-price">{jioPrimePointsRedeemed}</span>
            </section>
          ) : (
            ''
          )}
          {(orderSummary.hasOwnProperty('storeCredit') &&
            storeCreditRedeemed != '' &&
            showCredits) ||
          (orderSummary.hasOwnProperty('bankDiscount') && OfferBankDiscount != '') ||
          orderSummary.hasOwnProperty('loyaltyBurnedPoints') ||
          (orderSummary.hasOwnProperty('relianceOneAmount') && relianceOneAmount != '') ||
          (orderSummary.hasOwnProperty('redeemedMahaCachBack') && redeemedMahaCachBack != 0) ? (
            <section className="price-summary" id="orderTotal">
              <span className="label bold-font">
                {this.textContent.amountToBePaid}
              </span>
              <span className="price-value bold-font">
                {displayValueWithSymbol(
                  Math.abs(
                    orderValue -
                      creditRedeemed -
                      Math.abs(bankDiscount) -
                      Math.abs(loyaltyBurnedPoints) -
                      Math.abs(relianceOneAmountValue) -
                      Math.abs(redeemedMahaCachBack) -
                      Math.abs(noCostEmiDiscountTY)
                  ).toFixed(2)
                )}
              </span>
            </section>
          ) : (
            ''
          )}
          {orderSummary.hasOwnProperty('jioPrimePoint') &&
          jioPrimePointsRedeemed != '' &&
          showCredits ? (
            <section className="price-summary" id="orderTotal">
              <span className="label bold-font">
                {this.textContent.amountToBePaid}
              </span>
              <span className="price-value bold-font">
                {displayValueWithSymbol(Math.abs(orderValue - primePointRedeemed).toFixed(2))}
              </span>
            </section>
          ) : (
            ''
          )}
        </div>
        {this.renderAjioCashInfoModal()}
        {this.renderAjioCashInfoModalk()}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    ajioWalletData: { ajioWalletEarnData = {} },
    ordersData: { orderLevelDetail = {} },
    membership: { membershipData = {} } = {}
  } = state;
  const { product = {}, request = {}, cartItem = [], cart = {}, order = {}, flags } = state;
  const { isDesktopThemeEnable } = getLuxeFlags(flags);
  const storeName = getCurrentStore(state);
  const newDesignLuxe = isDesktopThemeEnable === 'ON' && storeName === 'luxe';
  const codConvenienceData = getCodConvenienceData(state);
  const freeShippingAmountLimit = getFreeShippingAmountLimit(state);
  const isOrderBlockedForCancellationFlagMsite = getBlockedForCancellationFlagMsite(flags);
  const enableGiftWithProduct = getGiftWithProductEnable(flags);
  const giftWithProductConfig = getGiftWithProductConfig(state);
  const isPriorityDeliveryFlagOn = getPriorityDeliveryPostOrderFlag(flags);
  const returnCodCommunication = getReturnCodCommunication(state);
  const enableRushDelivery = getRushDeliveryFlag(state);
  const isPaymentModesOnOrderPlacementFlag = getPaymentModesOnOrderPlacementFlag(flags);
  const ajioSuperCashCartConfig = getAjioSuperCashConfigForCart(flags);
  const ajioSuperCashCurrencyConfig = getAjioSuperCashCurrencyConfig(flags);
  const displayAjioWallet = getAjioWallet(state);
  const storeCreditValue = getStoreCredit(state);
  const ajioSuperCashODPEnable =
    getAjioSuperCashODPEnable(flags) && ['ajio', 'rilfnl', ''].includes(storeName.toLowerCase());
  const noCostEmiDiscountTitle = getEmiDiscountSPCConfig(state)?.noCostEmiDiscountTitle;

  return {
    ajioWalletEarnData,
    newDesignLuxe,
    codConvenienceData,
    orderLevelDetail,
    isOrderBlockedForCancellationFlagMsite,
    enableGiftWithProduct,
    giftWithProductConfig,
    isPriorityDeliveryFlagOn,
    isPaymentModesOnOrderPlacementFlag,
    enableAjioMemberShipProgram: getEnableAjioMemberShipProgram(state?.flags, state),
    ajioMembershipConfig: getAjioMemberShipConfig(state?.flags, state),
    membershipBenefitResponse: cart?.membershipBenefitResponse,
    memberShipStaticValues: state?.cacheData?.staticContent,
    returnCodCommunication,
    ajioSuperCashCartConfig,
    ajioSuperCashCurrencyConfig,
    displayAjioWallet,
    storeCreditValue,
    ajioSuperCashODPEnable,
    enableRushDelivery,
    noCostEmiDiscountTitle
  };
};

function mapDispatchToProps(dispatch, ownProps) {
  return {
    showModal: (name, config) => {
      dispatch(showModal(name, config));
    },
    hideModal: name => {
      dispatch(hideModal(name));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderSummary);
